export default __webpack_public_path__ + "static/media/Icon_Arrow-back.a4f10549.svg";